import React, { PropTypes } from 'react';

const Radio = React.createClass({

	propTypes: {
		options: PropTypes.array,
		value: PropTypes.oneOfType([
			PropTypes.array,
			PropTypes.string
		]).isRequired,
		onChange: PropTypes.func.isRequired
	},

	handleCheck(option, checked) {
		const { onChange, value } = this.props;

		if(checked) {
			onChange([...value, option]);
		} else {
			onChange(value.filter(v => v !== option));
		}
	},

	render() {
		const { options, value } = this.props;

		return (
			<div className="radio">
				{options.map((option, i) =>
					<label className="radio__btn" key={i} style={{display: 'inline-block'}}>
						<input
							onChange={e => this.handleCheck(option, e.target.checked)}
							type="checkbox"
							className="radio__inp"
							checked={value.indexOf(option) !== -1}
							/>
						<span className="radio__lbl">{option}</span>
					</label>
				)}
			</div>
		);
	}

});

export default Radio;


/** WEBPACK FOOTER **
 ** ./src/scripts/components/Radio.js
 **/